import {svgIconWrapper} from '../svg-icon-wrapper';

import IntegrationRegular from './integration-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <IntegrationRegular {...props} />;
}

SvgComponent.iconName = 'integrationRegular';

export const IntegrationRegularIcon = svgIconWrapper(SvgComponent);
